<template>

  <b-modal size="lg" v-model="isVisible" @hidden="onHidden" hide-footer>

    <b-alert show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <h4 class="text-center font-weight-bold text-primary mb-2">
        SOLICITUD-ANATOMIA PATOLOGICA
      </h4>

      <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success">
        <b-tab title="ESTUDIO / RESUMEN" active>
          <b-card>
            <b-row>
              <b-col cols="4">
                <span class="text-info">Servicio:</span>
                <b-form-radio-group v-model="form1.servicio" :options="opServicios" />
              </b-col>

              <b-col cols="2">
                <span class="text-info">Prioridad:</span>
                <b-form-radio-group v-model="form1.prioridad" :options="opPrioridad" />
              </b-col>

              <div class="col-5">
                <span class="text-info">Fecha y Hora de toma:</span>
                <b-form-input type="datetime-local" v-model="form1.fechaHoraToma" class="col-10" />
              </div>


            </b-row>

            <hr class="my-2">
            

            <div class="mt-1 row">
              <div class="col">
              <div class="my-1">
                <span class="text-info">Estudio Solicitado:</span>
                <b-form-radio-group v-model="form1.estudioSolicitado" :options="opEstudios" class="mb-1">
                </b-form-radio-group>
              </div>

              <div class="my-1" v-if="form1.estudioSolicitado === '5'">
                <span class="text-info">Descripcion de otro estudio solicitado:</span>
                <b-form-textarea v-model="form1.descripcionEstudio" />
              </div>
              </div>
              <div class="col">
                  <div class="my-1" >
                <span class="text-info">Procedimiento realizado para obtencion de muestra:</span>
                <b-form-textarea v-model="form1.procedimientoRealizado" />
              </div>
              </div>
            </div>

            <hr class="my-2" />

            <b-row class="mt-1">

              <div class="col-12 mb-1">
                <span class="text-info">Cuadro clinico:</span>
                <b-form-textarea v-model="form1.cuadroClinico" />
              </div>

              <div class="col-12 mb-1">
                <span class="text-info">Resultados de laboratorio:</span>
                <b-form-textarea v-model="form1.resultadosLaboratorio" />
              </div>

              <div class="col-12 mb-1">
                <span class="text-info">Datos imagen:</span>
                <b-form-textarea v-model="form1.datosImagen" />
              </div>

              <div class="col-12 mb-1">
                <span class="text-info">Tratamiento:</span>
                <b-form-textarea v-model="form1.tratamiento" />
              </div>
            </b-row>

          </b-card>
        </b-tab>

        <b-tab title="DATOS CITOLOGIA VAGINAL">
          <b-card>

            <b-row>
              <b-col>
              <span class="text-info">Material:</span>
              <b-form-checkbox-group v-model="form2.materiales" :options="opsMaterial" />
              </b-col>
              <b-col>
                <span class="text-info">Biologia Molecular y Genetica:</span>
                <b-form-textarea v-model="form2.biologiaMolecular"></b-form-textarea>
              </b-col>
            </b-row>

            <div class="row my-2">
              <span class="text-info">Descripcion Macroscopica:</span>
              <b-form-textarea v-model="form2.macroscopica" />
            </div>

            <div class="row my-2">
              <span class="text-info">Diagnostico de ultima citologia:</span>
              <b-form-textarea v-model="form2.ultimaCitologia" />
            </div>


            <label>Buscar diagnósticos:</label>
            <b-row class="my-1">
              <b-col cols="8">
                <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                  :minChars="3" :placeholder="'Buscar diagnostico...'" class="form-control-sm" />
              </b-col>
               <b-col cols="2" class="text-right">
                <b-form-checkbox variant="primary" size="md" v-model="definitivo">
                  Definitivo
                </b-form-checkbox>
              </b-col>
              <b-col cols="2" class="text-right">
                <b-button variant="primary" size="sm" @click="agregarDiagnostico">
                  Agregar
                </b-button>
              </b-col>
            </b-row>
            <b-row>

              <b-col class="my-4">
                <b-table class="my-4" v-if="form2.tableDiagnosticos && form2.tableDiagnosticos.length"
                  :items="form2.tableDiagnosticos" :fields="fieldsDiagnosticos" small>
                   <template #cell(tipo)="data">

                   {{ data.item.definitivo ? 'DEFINITIVO' : 'PRESUNTIVO' }}

                  </template>
                  <template #cell(acciones)="data">

                    <b-button class="text-center" variant="danger" size="sm" @click="removeDiagnostico(data.index)">
                      <font-awesome-icon icon="circle-xmark" style="color: white" />
                    </b-button>

                  </template>

                </b-table>
              </b-col>
            </b-row>



          </b-card>
        </b-tab>


        <b-tab title="MUESTRAS / RESPONSABLES">
          <b-card>
            <label>
              Muestra o Pieza / Número
            </label>
            <i class="fa-solid fa-circle-info ml-1" style="cursor: pointer;"
              title="Describir el origen y numero de muestras enviadas" />

            <b-form-textarea v-model="form3.muestras" />

            <hr class="my-3" />


            <div class="row d-flex align-items-center">
              <label class="col-3">Profesional que solicita:</label>
              <SearchOpts v-model="form3.doctor" :searchService="getDoctoresByEstablecimiento"
                :placeholder="'Buscar doctor responsable...'" :minChars="3" class="col" />
            </div>

            <div class="row d-flex align-items-center my-2">
              <label class="col-3">Fecha y hora de solicitud:</label>
              <b-form-input type="datetime-local" v-model="form3.fechaHoraSolicitud" class="form-control col-4 mx-1" />
            </div>


            <div class="row d-flex align-items-center mt-3">
              <label class="col-3">Entrega la muestra :</label>
              <SearchOpts v-model="form3.entregaMuestra" :searchService="getAuxiliarMedicoByEstablecimiento"
                :placeholder="'Buscar profesional responsable...'" :minChars="3" class="col" />
            </div>

            <div class="row d-flex align-items-center mt-2">
              <label class="col-3">Recibe la muestra:</label>
              <SearchOpts v-model="form3.recibeMuestra" :searchService="getAuxiliarMedicoByEstablecimiento"
                :placeholder="'Buscar profesional responsable...'" :minChars="3" class="col" />
            </div>


            <div class="row d-flex align-items-center my-2">
              <label class="col-3">Fecha hora de recepcion:</label>
              <b-form-input type="datetime-local" v-model="form3.fechaHoraRecepcion" class="form-control col-4 mx-1" />
            </div>


          </b-card>
        </b-tab>

     

      
        <b-tab title="SEMIOLOGIA GINECOLOGICA">
          <Form013aSemioGineco class="my-1" :dataGinecologia="dataGinecologia" @semiologia-enviada="recibirSemiologia"/>
        </b-tab>
         </b-tabs>

      <div class="text-right">
        <b-button variant="success" @click="onSave">
          Guardar
        </b-button>
      </div>

    </b-card>
  </b-modal>

</template>

<script>

import {
  BRow,
  BCol,
  BCard,
  BFormInput,
} from "bootstrap-vue";

import "flatpickr/dist/flatpickr.css";
import { diagnosticosService } from "../../../atencionMedica/services";
import { doctoresService, auxiliarService } from "@/shared/services";
import { SearchOpts } from '@/shared/components';
import { auxiliarMedicoService } from "@/views/administracion/services";
import { getEstablecimientoLS } from "@/shared/helpers";
import { procedimientosFormulariosService } from "../../services/procedimientosFormulariosService";
import Form013aSemioGineco from "./Form013aSemioGineco.vue";
import { ginecologiaService } from "../../../atencionCita/services";
import { procedimientosService } from "../../services";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    SearchOpts,
    Form013aSemioGineco
  },

  props: {
    isProceso: {
      type: Boolean,
      default: false
    },

    isLabAs400: {
      type: Boolean,
      default: false
    },

    isLabAux: {
      type: Boolean,
      default: false
    },

    tokenAtencion:{
      default:null,
      required:false
    }
  },


  created() {
    this.getData();
  },



  data() {
    return {


      tokenPrincipal: null,
      isVisible: false,
      formGeneral: null,

      idRegistroForm: null,

      messageAlert: {
        message: null,
        variant: null
      },

      fieldsDiagnosticos: [
        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center",
        },
         {
          key: "tipo",
          label: "Tipo",
          sortable: true,
          thClass: "text-center",
        },
        
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],

      searchDiagnostico: null,
      definitivo: false,
      diags: [],

      form1: {
        servicio: null,
        prioridad: null,
        fechaHoraToma: null,
        estudioSolicitado: null,
        descripcionEstudio: null,
        procedimientoRealizado:null,
        cuadroClinico: null,
        resultadosLaboratorio: null,
        datosImagen: null,
        tratamiento: null,
      },


      form2: {
        biologiaMolecular:null,
        materiales: [],
        macroscopica: null,
        ultimaCitologia: null,
        tableDiagnosticos: []
      },

      form3: {
        muestras: null,
        doctor: null,
        fechaHoraSolicitud: null,
        entregaMuestra: null,
        recibeMuestra: null,
        fechaHoraRecepcion: null
      },
      semiologia: null,
      dataGinecologia: null,

      doctoresService,
      auxiliarService,
      diagnosticosService,

      opsMaterial: [
        { text: 'Endocervix', value: '1' },
        { text: 'Exocervix', value: '2' },
        { text: 'Pared Vaginal', value: '3' },
        { text: 'Union Escamo', value: '4' },
        { text: 'Muñon Cervical', value: '5' }
      ],

      opEstudios: [
        { value: "1", text: "Histopatologia" },
        { value: "2", text: "Citologia" },
        { value: "3", text: "Revision de laminillas" },
        { value: "4", text: "Transoperatorio" },
        { value: "5", text: "Otros tipos de estudio" },
      ],

      opServicios: [
        { value: "1", text: "Emergencia" },
        { value: "2", text: "Consulta Externa" },
        { value: "3", text: "Hospitalizacion" },
      ],

      opPrioridad: [
        { value: "1", text: "Urgente" },
        { value: "2", text: "Rutina" },
      ],

    };
  },



  methods: {
    recibirSemiologia(obj) {
      this.semiologia = obj
      console.log("recibo semiologia", obj)
    },

    removeDiagnostico(index) {
      this.form2.tableDiagnosticos.splice(index, 1);
    },
    

    agregarDiagnostico() {
      if (!this.searchDiagnostico || !this.searchDiagnostico.text) {
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, seleccione un diagnóstico antes de agregar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }
       if (this.form2.tableDiagnosticos && this.form2.tableDiagnosticos.length > 5 ) {
        this.$swal({
          title: "Diagnosticos completos",
          text: "No puede agregar mas de 6 diagnosticos.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }
      let definitivos = []
      let presuntivos = []
      if (this.form2.tableDiagnosticos.length){
        this.form2.tableDiagnosticos.forEach(element => {
          if(element.definitivo){definitivos.push(element)}
          if(!element.definitivo){presuntivos.push(element)}
        });
      }

      if (this.definitivo && definitivos.length > 2 ) {
        this.$swal({
          title: "Diagnosticos DEFINITIVOS completos",
          text: "No puede agregar mas diagnosticos DEFINITIVOS.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }
      if (!this.definitivo && presuntivos.length > 2 ) {
        this.$swal({
          title: "Diagnosticos PRESUNTIVOS completos",
          text: "No puede agregar mas diagnosticos PRESUNTIVOS.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      const nuevoDiagId = {
        diag: this.searchDiagnostico?.value,
        definitivo : this.definitivo
      };

      const nuevoDiagnostico = {
        diagnostico: this.searchDiagnostico?.text,        
        definitivo : this.definitivo,
        codigo: this.searchDiagnostico?.codigo,
        descripcion :this.searchDiagnostico?.descripcion
      };

      console.log(this.searchDiagnostico)

      this.form2.tableDiagnosticos.push(nuevoDiagnostico);
      this.diags.push(nuevoDiagId);

      this.searchDiagnostico = null
      this.definitivo = false
    },

    async getDoctoresByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();
      const responseDoctores = await doctoresService.searchDoctoresByTermSelect(search, establecimiento.id);

      const responseMap = responseDoctores.map(item => ({
        value: item.value,
        text: item.text,
        especialidad: item.especialidad
      }));

      return responseMap;
    },


    async getAuxiliarMedicoByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();

      const params = {
        search,
        establecimiento: establecimiento.id
      }

      const responseAux = await auxiliarMedicoService.getAll(params);
      const auxiliares = responseAux?.auxiliares;
      const responseMap = auxiliares.map(item => ({
        value: item.id,
        text: item.text,
      }));

      return responseMap;
    },

    clearForm() {
      this.dataGinecologia = null
      this.diags = []

      this.form1 = {
        servicio: null,
        prioridad: null,
        fechaHoraToma: null,
        estudioSolicitado: null,
        descripcionEstudio: null,
        procedimientoRealizado:null,
        cuadroClinico: null,
        resultadosLaboratorio: null,
        datosImagen: null,
        tratamiento: null,
      }

      this.form2 = {
        biologiaMolecular:null,
        materiales: [],
        macroscopica: null,
        ultimaCitologia: null,
        tableDiagnosticos:[]
      }

      this.form3 = {
        muestras: null,
        doctor: null,
        fechaHoraSolicitud: null,
        entregaMuestra: null,
        recibeMuestra: null,
        fechaHoraRecepcion: null
      }

      this.messageAlert = {
        message: null,
        variant: null
      }

      this.semiologia = {
        menarquia: "",
        menopausia: "",
        ciclos: "",
        inicioSexual: "",
        gestas: "",
        partos: "",
        abortos: "",
        cesareas: "",
        hijosVivos: "",
        planificacionFamiliar: "",
        terapiaHormonal: "",
        ultimaMenstruacion: "",
        ultimoParto: "",
        citologiaCervical: "",
        colposcopia: "",
        mamografia: "",
        antigenoProstatico: "",
        ecoProstatico: "",
        analisis: "",
      }
    },


    async getData() {

      this.clearForm();
      this.tokenPrincipal = this.$route.query.forms;

      const tokenFormulario = this.$route.query["13a"];

      if (!this.tokenPrincipal) return;

      const dataProcedimiento = await procedimientosService.getByToken(this.tokenPrincipal);
      
      if (dataProcedimiento) {
        this.form1.procedimientoRealizado = `${dataProcedimiento.procedimiento.codigo}-${dataProcedimiento.procedimiento.descripcion}`
        console.log("data proc", this.form1.procedimientoRealizado)
      }
      const responseFormulario = await procedimientosFormulariosService.obtenerFormProcDataByToken(tokenFormulario);
     
      
      
      if (!responseFormulario) {
        
        const dataGinecologia = await ginecologiaService.getAntecedentesByAtencion(this.tokenAtencion)
        this.dataGinecologia = dataGinecologia?.dataItems
        
      

        this.messageAlert = {
          text: 'No existe informacion registrada',
          variant: 'info'
        };

        this.isVisible = true;
        return;
      }

      const dataF13a = responseFormulario;
      this.idRegistroForm = dataF13a.id;

      if (dataF13a.dataJson) {
        let dataForm = JSON.parse(dataF13a.dataJson);

        console.log("data form", dataForm)

        this.messageAlert = {
          text: 'Informacion registrada',
          variant: 'success'
        };

        if (!dataForm.form2.tableDiagnosticos) {
          dataForm.form2.tableDiagnosticos = []
        }

        if (dataForm.form1) this.form1 = dataForm.form1;
        if (dataForm.form2) this.form2 = dataForm.form2;
        if (dataForm.form3) this.form3 = dataForm.form3;
        if (dataForm.semiologia) this.semiologia = dataForm.semiologia
        this.dataGinecologia = this.semiologia
       
      }

      this.isVisible = true;
    },


    async onSave() {
      this.isVisible = false;

      const dataJson = JSON.stringify(this.formGeneral);


      const params = {
        nameForm: '13a',
        dataJson: dataJson,
        idRegistroForm: this.idRegistroForm,
        tokenProceso: this.tokenPrincipal || null,
        tokenLabAux: this.isLabAux ? this.tokenPrincipal : null,
        tokenLabAs400: this.isLabAs400 ? this.tokenPrincipal : null
      }

      console.log("params que envio", params)

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        await this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal({
        title: "Guardado",
        text: "Guardado correctamente",
        icon: "success",
        confirmButtonColor: "#089599",
      });

      this.$emit("formulario-guardado");

      this.isVisible = false;
    },


    onHidden() {
      this.isVisible = false;
    },

  },


  watch: {

    '$route.query.13a': {
      handler(newValue) {
        if (newValue) {
          this.getData();
        }

      },
    },


    form1: {
      deep: true,
      handler(newValue) {
        this.formGeneral = {
          ...this.formGeneral,
          form1: newValue
        }
      }
    },


    form2: {
      deep: true,
      handler(newValue) {

        this.formGeneral = {
          ...this.formGeneral,
          form2: newValue
        }
      }
    },

    form3: {
      deep: true,
      handler(newValue) {
        this.formGeneral = {
          ...this.formGeneral,
          form3: newValue
        }
      }
    },

    semiologia: {
      deep: true,
      handler(newValue) {
        this.formGeneral = {
          ...this.formGeneral,
          semiologia: newValue
        }
      }
    },

    

    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery["13a"];
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  },
};
</script>
